<template>
  <div
    class="flex items-center w-[20px] h-[20px] text-lightblue cursor-pointer"
    :class="'bookmark-' + bookmarkId"
    @click="addRemoveBookmark(isBookmarked)"
  >
    <img
      v-if="isBookmarked"
      src="/assets/images/bookmarkFilled.svg"
      alt="bookmarkFilled"
      class="font-semibold font-aktiv-grotex-trial w-full h-full"
    />
    <img
      v-else
      src="/assets/images/bookmark.svg"
      alt="bookmark"
      class="font-semibold font-aktiv-grotex-trial w-full h-full text-[#99A4B2]"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";
export default {
  props: {
    bookmarkId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState("user", ["token"]),
    ...mapState("filter", ["bookMarkMap"]),
    isBookmarked() {
      return this.bookMarkMap?.[this.bookmarkId] || false;
    },
  },
  methods: {
    async addRemoveBookmark(
      flag,
      { locale = "en", conferenceType = "GIC" } = {}
    ) {
      const params = {
        videoId: this.bookmarkId,
        isBookmarked: !flag,
      };
      const { status, data } = await axios.post(
        process.env.VUE_APP_API_URL + "/videoprogress",
        params,
        {
          headers: {
            Authorization: `Bearer ${this.token}`, // Or 'Basic ${base64EncodedCredentials}' for Basic Auth
          },
          params: {
            locale: locale,
            conferenceType: conferenceType,
          },
        }
      );

      await this.$store.dispatch("filter/toggleBookMark", {
        type: this.type,
        slug: this.bookmarkId,
      });
      await this.$store.dispatch("filter/toggleBookMarkList", {
        type: this.type,
        slug: this.bookmarkId,
        flag: !flag,
      });
    },
  },
};
</script>

<style scoped></style>
